import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Pages
import LandingPage from './pages/LandingPage';
import SchoolSelection from './pages/SchoolSelection';
import SchoolsMapPage from './pages/SchoolsMapPage';
import OccasionSelection from './pages/OccasionSelection';
import OrderForm from './pages/OrderForm';
import PaymentPage from './pages/PaymentPage';
import OrderConfirmation from './pages/OrderConfirmation';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import HelpCenterPage from './pages/HelpCenterPage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import BandDirectorsPage from './pages/BandDirectorsPage';
import BandSignupPage from './pages/BandSignupPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';

// Components
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/help" element={<HelpCenterPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/band-directors" element={<BandDirectorsPage />} />
          <Route path="/band-signup" element={<BandSignupPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/schools" element={<SchoolSelection />} />
          <Route path="/schools-map" element={<SchoolsMapPage />} />
          <Route path="/schools/:schoolId/occasions" element={<OccasionSelection />} />
          <Route path="/schools/:schoolId/occasions/:occasion/order" element={<OrderForm />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/confirmation" element={<OrderConfirmation />} />
        </Routes>
        
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#22c55e',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;
